import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-italic",
  "use": "icon-italic-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-italic\"><path d=\"M779.71 129.73V44.17H523.03v85.56h70.83L362.89 898.61h-96.54v85.56h256.68v-85.56H452.2l230.98-768.88z\" p-id=\"4716\" fill=\"#000000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol